import { render, staticRenderFns } from "./FairMines.vue?vue&type=template&id=0a7e1389&scoped=true"
import script from "./FairMines.vue?vue&type=script&lang=js"
export * from "./FairMines.vue?vue&type=script&lang=js"
import style0 from "./FairMines.vue?vue&type=style&index=0&id=0a7e1389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7e1389",
  null
  
)

export default component.exports